// ... 现有代码 ...

export const registerLazyDirective = app => {
  // ... 现有指令 ...

  // 懒加载指令
  app.directive('lazy', {
    mounted(el, binding) {
      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const { value } = binding
              if (typeof value === 'function') {
                value()
              } else if (value && value.callback) {
                value.callback()
              }
              observer.unobserve(el)
            }
          })
        },
        {
          root: binding.value?.root || null,
          rootMargin: binding.value?.rootMargin || '50px',
          threshold: binding.value?.threshold || 0.1,
        }
      )

      observer.observe(el)
      el._lazyObserver = observer
    },

    unmounted(el) {
      if (el._lazyObserver) {
        el._lazyObserver.disconnect()
        delete el._lazyObserver
      }
    },
  })

  // ... 其他现有指令 ...
}
